import kaplay from "kaplay";

import { game } from "./scenes/game";
import { end } from "./scenes/end";
import { makeTransitionComps, generateStars } from "./utils";

const FOREGROUND_COLOR_HEX = "#306230"
const BACKGROUND_COLOR_HEX = "#8bac0f"

const k = kaplay({
  background: BACKGROUND_COLOR_HEX,
  width: 640,
  height: 480,
  maxFPS: 60,
});

const foregroundColor = k.Color.fromHex(FOREGROUND_COLOR_HEX)

k.loadSpriteAtlas("sprites/main-sheet.png", {
  "plant_1": {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  },
  "plant_2": {
    x: 32,
    y: 0,
    width: 32,
    height: 32
  },
  "blob": {
    x: 0,
    y: 32,
    width: 64,
    height: 32,
    sliceX: 2,
    anims: {
      idle: { from: 0, to: 1, loop: true, speed: 2 }
    }
  },
  "hearth": {
    x: 64,
    y: 0,
    width: 32,
    height: 32
  },
  "bag": {
    x: 96,
    y: 0,
    width: 32,
    height: 32
  },
  "cross": {
    x: 64,
    y: 32,
    width: 32,
    height: 32
  },
  "tear": {
    x: 96,
    y: 32,
    width: 32,
    height: 32
  },
  "clock": {
    width: 32,
    height: 32,
    x: 0,
    y: 64,
  },
  "plant_3": {
    x: 32,
    y: 64,
    width: 32,
    height: 32
  },
  "plant_4": {
    x: 64,
    y: 64,
    width: 32,
    height: 32
  }
})



k.loadSprite("shop", "sprites/shop.png", {
  sliceX: 6,
  sliceY: 1,
  anims: {
    idle: {
      loop: true,
      speed: 2,
      from: 0,
      to: 5
    }
  }
})

k.loadMusic("bg", "sounds/bg.mp3")
k.loadSound("click", "sounds/click.mp3")
k.loadSound("happy", "sounds/happy.mp3")
k.loadSound("error", "sounds/hitHurt.mp3")



k.loadSprite("logo", "sprites/logo.png")


k.loadRoot("./"); // A good idea for Itch.io publishing later

k.scene("game", () => { game(k) })

k.scene("title", () => {


  const title = k.add(
    [
      k.pos(k.center().add(k.vec2(0, -60))),
      k.sprite("logo"),
      k.anchor("center"),
      k.scale(1.5),
      k.animate(),
    ]
  )

  const initialPosition = title.pos

  title.animate("pos", [initialPosition, initialPosition.add(k.vec2(0, 20))], {
    duration: 1,
    direction: "ping-pong"
  })


  const buttonToPlay = k.add([
    k.rect(350, 50, {
      radius: 2
    }),
    k.outline(8, foregroundColor),
    k.color(BACKGROUND_COLOR_HEX),
    k.anchor("center"),
    k.pos(k.center().add(k.vec2(0, k.height() / 3)))
  ])

  generateStars(k, 150, k.width(), k.height())

  buttonToPlay.add([
    k.text("Press Space to play"),
    k.anchor("center"),
    k.scale(0.8),
    k.color(foregroundColor)
  ])

  k.onKeyPress("space", () => {
    k.add(makeTransitionComps(k, () => {
      k.play("click")
      k.go("game")
    }))
  })

})

k.scene("end", (score) => {
  end(k, score)
})

k.go("title")
